import React from 'react';
import { Box, Flex } from '@skin-seoul/design-system';
import type { CarouselApi } from './Carousel';
import Image from 'next/image';
import PreviousPageButton from './assets/previous-page-putton.svg';
import NextPageButton from './assets/next-page-button.svg';
interface CarouselNavigationProps {
  api: CarouselApi | undefined;
  activeIndex: number;
  totalItems: number;
  onPrevClick?: () => void;
  onNextClick?: () => void;
  onDotClick?: (index: number) => void;
}
const CarouselNavigation = ({
  api,
  activeIndex,
  totalItems,
  onPrevClick,
  onNextClick,
  onDotClick
}: CarouselNavigationProps) => {
  const handlePrevClick = () => {
    if (onPrevClick) {
      onPrevClick();
    } else {
      api?.scrollPrev();
    }
  };
  const handleNextClick = () => {
    if (onNextClick) {
      onNextClick();
    } else {
      api?.scrollNext();
    }
  };
  const handleDotClick = (index: number) => {
    if (onDotClick) {
      onDotClick(index);
    } else {
      api?.scrollTo(index);
    }
  };
  return <Flex alignItems="center" gap={14} justifyContent="center" width="100%" h="24px" data-sentry-element="Flex" data-sentry-component="CarouselNavigation" data-sentry-source-file="CarouselNavigation.tsx">
      <Flex alignItems="center" cursor="pointer" justifyContent="center" onClick={handlePrevClick} padding={2} transition="all 0.2s" _hover={{
      transform: 'translateX(-4px)'
    }} data-sentry-element="Flex" data-sentry-source-file="CarouselNavigation.tsx">
        <Image src={PreviousPageButton} alt="MoveLeft" width={54} height={24} color="neutral.800" data-sentry-element="Image" data-sentry-source-file="CarouselNavigation.tsx" />
      </Flex>

      <Flex alignItems="center" gap={1} data-sentry-element="Flex" data-sentry-source-file="CarouselNavigation.tsx">
        {Array.from({
        length: totalItems
      }, (_, index) => <Box key={index} width={activeIndex === index ? 5 : 3} height={1} backgroundColor={activeIndex === index ? 'neutral.800' : 'neutral.100'} borderRadius="4px" cursor="pointer" transition="all 0.2s" onClick={() => handleDotClick(index)} _hover={{
        backgroundColor: activeIndex === index ? 'neutral.500' : 'neutral.300'
      }} />)}
      </Flex>

      <Flex alignItems="center" cursor="pointer" justifyContent="center" onClick={handleNextClick} padding={2} transition="all 0.2s" _hover={{
      transform: 'translateX(4px)'
    }} data-sentry-element="Flex" data-sentry-source-file="CarouselNavigation.tsx">
        <Image src={NextPageButton} alt="MoveRight" width={54} height={24} data-sentry-element="Image" data-sentry-source-file="CarouselNavigation.tsx" />
      </Flex>
    </Flex>;
};
export default CarouselNavigation;